import {shouldSkipLazyLoadCompat} from 'app/components/textWithImageSSR/shouldSkipLazyLoad';
import {TextWithVideoLazy} from 'app/components/textWithVideo/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineTextWithVideo(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-text-with-video')) {
        return;
    }

    customElements.define(
        'gem-text-with-video',
        class extends WebComponentLoader {
            reactLazyComponent = TextWithVideoLazy;
            shouldSkipLazyLoad = shouldSkipLazyLoadCompat;
        },
    );
}
